import styled from 'styled-components'
import { PropTypesStyledHTML } from '../../../../utils/styled_helpers'

export const Button = styled.button<PropTypesStyledHTML>`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border: 2px solid #000000;
  box-sizing: border-box;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  font-weight: bold;
  font-size: 24px;
  font-family: Poppins;
  padding-left: ${({ pl }) => pl};;
  padding-right: ${({ pr }) => pr};;
  cursor: pointer;

  &:hover {
    background: linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%);
    border: 2px solid #000000;
    box-sizing: border-box;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
  }

  &:disabled {
    background: linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%);
    opacity: 0.1;
    border: 2px solid #000000;
    box-sizing: border-box;
    /* img shadow */

    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
  }
`
